import { Component, OnInit } from "@angular/core";
import { MDBModalRef } from "ng-uikit-pro-standard";
import { UICalendarEvent } from "src/app/venue";
import * as moment from "moment";
import { FirebaseService, DateService } from "src/app/core";
import { Router } from "@angular/router";
import { Product } from "src/app/core/product/product";
import { ScheduleType } from "src/app/core/product/enums";
@Component({
  selector: "ll-date-details-popup",
  templateUrl: "./date-details-popup.component.html",
  styleUrls: ["./date-details-popup.component.scss"]
})
export class DateDetailsPopupComponent implements OnInit {
  ds: DateService = new DateService();
  events: UICalendarEvent[]; //Injected from ScheduleCardComponent
  date: Date;
  constructor(
    public modalRef: MDBModalRef,
    public fb: FirebaseService,
    public router: Router
  ) {}

  ngOnInit(): void {}

  get header(): string {
    return moment(this.date).format("MMM DD, YYYY (ddd)");
  }

  get hasEvents(): boolean {
    return this.events.length != 0;
  }

  get products(): Product[] {
    return this.fb.venue.products;
  }

  get hasProducts(): boolean {
    return this.applicable.length != 0;
  }
  get isAdmin(): string {
    return this.router.url.includes("admin") ? "/admin" : "";
  }

  get applicable(): Product[] {
    return this.products.reduce((list, product) => {
      const isActive = product.isActive;
      const isCustomDateSchedule =
        product.scheduleType == ScheduleType.CustomDays;
      const isAlreadyAssignedToDate = product.events.some(event =>
        this.ds.isSameDate(event.date, this.date)
      );
      if (isActive && isCustomDateSchedule && !isAlreadyAssignedToDate)
        list.push(product);
      return list;
    }, []);
  }
  addPass() {
    if (this.hasProducts) {
      //Take to Add A Pass
    } else {
      //Close Modal
      this.modalRef.hide();
      this.fb.venue.initBuilder();
      this.router.navigateByUrl(`${this.isAdmin}/venue/passes`);
      //Navigate to Add New Pass Form
    }
  }

  details(pass: Product) {
    this.fb.venue.initBuilder(pass);
    this.modalRef.hide();
    this.router.navigateByUrl(`${this.isAdmin}/venue/passes`);
  }

  schedule(pass: Product) {
    this.fb.venue.initBuilder(pass);
    this.modalRef.hide();
    this.router.navigateByUrl(`${this.isAdmin}/venue/passes`);
  }
}
